import { Icon } from '@components';
import { routes } from '@constants';
import { useNavigateWithOfflineMode } from '@hooks';
import CertificateSmall from '@pngs/certificate.png';
import { Flex, Image, theme, Typography } from '@styles';
import { ReactComponent as Download } from '@svgs/download2.svg';
import { ReactComponent as Settings } from '@svgs/settings.svg';
import { string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import generatePDF, { Margin } from 'react-to-pdf';
import { Certificate } from 'src/components/Certificate';
import { getDataFromLS } from 'src/components/CookiesModal/CookiesModal.propTypes';

const options = {
  canvas: {
    mimeType: 'image/png',
    qualityRatio: 1,
  },
  method: 'save',
  page: {
    format: 'letter',
    margin: Margin.SMALL,
    orientation: 'landscape',
  },
};

const CertificateInfo = ({ date, title }) => {
  const certificateRef = useRef();
  const { language } = useTranslation();

  const [isDownloading, setIsDownloading] = useState(false);
  const getTargetElement = () => document.getElementById('content-id');
  const { navigate } = useNavigateWithOfflineMode();
  const [existingData, setExistingData] = useState({
    name: null,
  });

  const isPossibleToDownload = existingData.name && title && date;

  useEffect(() => {
    setExistingData({
      language: getDataFromLS('certificateLanguage'),
      name: getDataFromLS('certificateName'),
    });
  }, []);

  const handleCertificateDownload = async () => {
    if (!isPossibleToDownload) {
      return;
    }

    try {
      setIsDownloading(true);
      await generatePDF(getTargetElement, options);

      setIsDownloading(false);
    } catch (error) {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <Flex background="rgba(255, 255, 255, 0.16)" p={24}>
        <Image height="146px" mr={32} src={CertificateSmall} width="270px" />
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Flex flexDirection="column">
            <Typography
              color={theme.colors.white[100]}
              opacity="0.7"
              variant="MS-semibold-s16-lh25"
            >
              {date}
            </Typography>
            <Typography
              color={theme.colors.white[100]}
              marginTop="8px"
              variant="MS-bold-s20-lh21"
            >
              {title}
            </Typography>
          </Flex>
          <Flex>
            <Icon
              height={40}
              mr={16}
              onClick={handleCertificateDownload}
              opacity={isPossibleToDownload && !isDownloading ? 1 : 0.5}
              style={{ cursor: 'pointer' }}
              SVG={Download}
              width={40}
            />
            <Icon
              height={40}
              onClick={() =>
                navigate(routes.certificateSettings, { state: { date, title } })
              }
              style={{ cursor: 'pointer' }}
              SVG={Settings}
              width={40}
            />
          </Flex>
        </Flex>
      </Flex>

      <div style={{ opacity: '0', position: 'absolute', zIndex: -100 }}>
        <div ref={certificateRef} id="content-id">
          <Certificate
            date={date}
            isPDFGenerationVariant
            language={existingData?.language || language}
            name={existingData.name}
            title={title}
            withExtraMargin
          />
        </div>
      </div>
    </>
  );
};

CertificateInfo.propTypes = {
  date: string.isRequired,
  title: string.isRequired,
};

export default CertificateInfo;
